import type { SxProps, Theme } from '@mui/material/styles'

type ProfilePageStyleMap = {
    root: SxProps<Theme>
    card: SxProps<Theme>
    cardHeader: SxProps<Theme>
    cardContent: SxProps<Theme>
    messageAlert: SxProps<Theme>
    saveActions: SxProps<Theme>
    passwordHeader: SxProps<Theme>
}

export const profilePageStyles: ProfilePageStyleMap = {
    root: { maxWidth: 720, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 3 },
    card: { border: '1px solid', borderColor: 'divider', borderRadius: 2 },
    cardHeader: { px: 3, py: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid', borderColor: 'divider' },
    cardContent: { p: 3 },
    messageAlert: { mb: 2 },
    saveActions: { mt: 3, display: 'flex', justifyContent: 'flex-end' },
    passwordHeader: { px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider' },
}
